import { render, staticRenderFns } from "./TakePhotoDialog.vue?vue&type=template&id=b1022d46&scoped=true"
import script from "./TakePhotoDialog.vue?vue&type=script&lang=js"
export * from "./TakePhotoDialog.vue?vue&type=script&lang=js"
import style0 from "./TakePhotoDialog.vue?vue&type=style&index=0&id=b1022d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1022d46",
  null
  
)

export default component.exports